// ======================================================================
// File Name       : box
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const BOX_RECEIVE_BOX_LIST = 'BOX_RECEIVE_BOX_LIST';
export const BOX_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG = 'BOX_INIT_DATA_FOR_DETAIL_EDIT_CONFIRM_DIALOG';
export const BOX_INIT_DATA_FOR_REGISTER_DIALOG = 'BOX_INIT_DATA_FOR_REGISTER_DIALOG';
export const BOX_INPUT_CHANGE = 'BOX_INPUT_CHANGE';
export const BOX_CHANGE_DATA = 'BOX_CHANGE_DATA';
export const BOX_GET_THUMBNAIL_DEFAULT = 'BOX_GET_THUMBNAIL_DEFAULT';
export const BOX_SAVE_DETAIL_SETTING_STATE = 'BOX_SAVE_DETAIL_SETTING_STATE';
